/**
 * Indicador de digitação
 * Exibe animação de 3 pontos pulsantes
 */

import React from 'react';

interface TypingIndicatorProps {
  primaryColor: string;
}

export const TypingIndicator: React.FC<TypingIndicatorProps> = ({ primaryColor }) => {
  // Estilos do container
  const containerStyles: React.CSSProperties = {
    display: 'flex',
    alignItems: 'flex-start',
    padding: '0 12px',
    marginBottom: '12px',
  };

  // Estilos da bolha
  const bubbleStyles: React.CSSProperties = {
    backgroundColor: '#f3f4f6',
    borderRadius: '18px 18px 18px 4px',
    padding: '12px 16px',
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
  };

  // Estilos do ponto
  const dotStyles: React.CSSProperties = {
    width: '8px',
    height: '8px',
    borderRadius: '50%',
    backgroundColor: '#9ca3af',
    animation: 'typingBounce 1.4s infinite ease-in-out',
  };

  return (
    <>
      <style>
        {`
          @keyframes typingBounce {
            0%, 60%, 100% {
              transform: translateY(0);
              opacity: 0.4;
            }
            30% {
              transform: translateY(-4px);
              opacity: 1;
            }
          }
        `}
      </style>
      
      <div style={containerStyles}>
        <div style={bubbleStyles}>
          <span style={{ ...dotStyles, animationDelay: '0ms' }} />
          <span style={{ ...dotStyles, animationDelay: '200ms' }} />
          <span style={{ ...dotStyles, animationDelay: '400ms' }} />
        </div>
      </div>
    </>
  );
};
